import { socialIcons } from "./socialIcons";

export const socialIconsData = [
  {
    name: 'GitHub',
    url: 'https://github.com/maxFadet',
    icon: socialIcons.Github
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/averybodymax',
    icon: socialIcons.Facebook
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/max-padrabinkin-4a739a251/',
    icon: socialIcons.LinkedIN
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/prost0max/',
    icon: socialIcons.Instagram
  }
];